webpackJsonp([1],{

/***/ 187:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GanttLegend_vue__ = __webpack_require__(189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_305456fa_node_modules_vue_loader_lib_selector_type_template_index_0_GanttLegend_vue__ = __webpack_require__(190);
function injectStyle (ssrContext) {
  __webpack_require__(188)
}
var normalizeComponent = __webpack_require__(4)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-305456fa"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GanttLegend_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_305456fa_node_modules_vue_loader_lib_selector_type_template_index_0_GanttLegend_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 188:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 189:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    rows: {
      type: Array,
      required: true
    },
    legendHelp: {
      type: String,
      required: true
    }
  }
});

/***/ }),

/***/ 190:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vue-gantt-legend"
  }, [_c('div', {
    staticClass: "title",
    attrs: {
      "title": _vm.legendHelp
    }
  }, [_vm._v("Legend (?)")]), _vm._v(" "), _vm._l((_vm.rows), function(row, index) {
    return _c('div', {
      key: index,
      staticClass: "task",
      attrs: {
        "title": ("From " + (row.from) + " to " + (row.to))
      },
      on: {
        "click": function($event) {
          _vm.$emit('task-click', row.start)
        }
      }
    }, [_c('span', {
      staticClass: "task-name"
    }, [_vm._v(_vm._s(row.name))]), _vm._v(" "), _c('span', {
      staticClass: "task-link"
    }, [_c('a', {
      attrs: {
        "href": row.link,
        "target": "_blank"
      }
    }, [_vm._v("...")])])])
  })], 2)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 191:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GanttHeader_vue__ = __webpack_require__(193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_63ec7303_node_modules_vue_loader_lib_selector_type_template_index_0_GanttHeader_vue__ = __webpack_require__(194);
function injectStyle (ssrContext) {
  __webpack_require__(192)
}
var normalizeComponent = __webpack_require__(4)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GanttHeader_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_63ec7303_node_modules_vue_loader_lib_selector_type_template_index_0_GanttHeader_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 192:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 193:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    rows: {
      type: Array,
      required: true
    }
  }
});

/***/ }),

/***/ 194:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vue-gantt-header"
  }, _vm._l((_vm.rows), function(row, idx) {
    return _c('div', {
      key: idx,
      staticClass: "gantt-row"
    }, _vm._l((row), function(obj, idx) {
      return _c('div', {
        key: idx,
        staticClass: "row-item",
        style: ({
          width: obj.width + 'px'
        }),
        attrs: {
          "title": obj.title
        },
        on: {
          "click": function($event) {
            _vm.$emit('header-click', obj)
          }
        }
      }, [_vm._v("\n      " + _vm._s(obj.label) + "\n    ")])
    }))
  }))
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 195:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GanttBody_vue__ = __webpack_require__(197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_271491d0_node_modules_vue_loader_lib_selector_type_template_index_0_GanttBody_vue__ = __webpack_require__(198);
function injectStyle (ssrContext) {
  __webpack_require__(196)
}
var normalizeComponent = __webpack_require__(4)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GanttBody_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_271491d0_node_modules_vue_loader_lib_selector_type_template_index_0_GanttBody_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 196:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 197:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    tasks: {
      type: Array,
      required: true
    }
  }
});

/***/ }),

/***/ 198:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vue-gantt-body"
  }, _vm._l((_vm.tasks), function(task, idx) {
    return _c('div', {
      key: idx,
      staticClass: "task"
    }, _vm._l((task), function(ref, idx) {
      var display = ref.display;
      var desc = ref.desc;
      var color = ref.color;
      var width = ref.width;
      var offset = ref.offset;
      var from = ref.from;
      var to = ref.to;

      return _c('div', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (display),
          expression: "display"
        }],
        key: idx,
        staticClass: "interval",
        style: ({
          'background-color': color,
          width: width + 'px',
          'margin-left': offset + 'px'
        }),
        attrs: {
          "title": (desc + ", 'From' " + from + " 'to' " + to)
        }
      }, [_vm._v("\n      " + _vm._s(desc) + "\n    ")])
    }))
  }))
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 199:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GanttFooter_vue__ = __webpack_require__(201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_42ba0f11_node_modules_vue_loader_lib_selector_type_template_index_0_GanttFooter_vue__ = __webpack_require__(202);
function injectStyle (ssrContext) {
  __webpack_require__(200)
}
var normalizeComponent = __webpack_require__(4)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GanttFooter_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_42ba0f11_node_modules_vue_loader_lib_selector_type_template_index_0_GanttFooter_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 200:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 201:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    startDate: {
      type: Number,
      required: true
    },
    endDate: {
      type: Number,
      required: true
    },
    step: {
      type: Number,
      required: true
    },
    scales: {
      type: Array,
      required: true
    },
    period: {
      type: Number,
      required: true
    },
    selected: {
      type: Number,
      required: true
    }
  }
});

/***/ }),

/***/ 202:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vue-gantt-footer"
  }, [_c('input', {
    staticClass: "scroll",
    attrs: {
      "type": "range",
      "min": _vm.startDate,
      "max": _vm.endDate,
      "step": _vm.step
    },
    domProps: {
      "value": _vm.period
    },
    on: {
      "input": function($event) {
        _vm.$emit('period-change', $event)
      }
    }
  }), _vm._v(" "), _c('select', {
    domProps: {
      "value": _vm.scales[_vm.selected]
    },
    on: {
      "change": function($event) {
        _vm.$emit('scale-change', $event)
      }
    }
  }, _vm._l((_vm.scales), function(scale) {
    return _c('option', {
      key: scale,
      domProps: {
        "value": scale
      }
    }, [_vm._v(_vm._s(scale))])
  }))])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 203:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vue-gantt gantt-column"
  }, [_c('div', {
    staticClass: "gantt-row"
  }, [_c('gantt-legend', {
    ref: "legend",
    attrs: {
      "rows": _vm.tasks,
      "legendHelp": _vm.legendHelp
    },
    on: {
      "task-click": _vm.handleTaskClick
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gantt-column",
    style: ({
      width: _vm.cellsCount * 24
    }),
    on: {
      "wheel": function($event) {
        $event.preventDefault();
        _vm.handleWheel($event)
      }
    }
  }, [_c('gantt-header', {
    attrs: {
      "rows": _vm.header
    },
    on: {
      "header-click": _vm.handleHeaderClick
    }
  }), _vm._v(" "), _c('gantt-body', {
    attrs: {
      "tasks": _vm.body
    }
  })], 1)], 1), _vm._v(" "), _c('gantt-footer', {
    attrs: {
      "scales": _vm.scales,
      "selected": _vm.selectedScaleIdx,
      "startDate": _vm.min,
      "endDate": _vm.max,
      "step": _vm.msInCell,
      "period": _vm.viewportStart
    },
    on: {
      "scale-change": _vm.handleScaleChange,
      "period-change": _vm.handlePeriodChange
    }
  })], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 204:
/***/ (function(module, exports) {

module.exports = {
	"rows": [
		{
			"name": "Шаг 1",
			"link": "#0",
			"values": [
				{
					"desc": "Шаг 1",
					"from": 1334836925000,
					"to": 1334837045000,
					"color": "#D0E4FD"
				}
			]
		},
		{
			"name": "Шаг 23",
			"link": "#0",
			"values": [
				{
					"desc": "Шаг 23",
					"from": 1334837045000,
					"to": 1334837183000,
					"color": "#D0E4FD"
				}
			]
		},
		{
			"name": "Шаг 1",
			"link": "#0",
			"values": [
				{
					"desc": "Шаг 1 просрочен",
					"from": 1334923578000,
					"to": 1334929209000,
					"color": "#F9C4E1"
				},
				{
					"desc": "Шаг 1",
					"from": 1334837183000,
					"to": 1334923578000,
					"color": "#D0E4FD"
				}
			]
		},
		{
			"name": "Шаг 23",
			"link": "#0",
			"values": [
				{
					"desc": "Шаг 23 просрочен",
					"from": 1334964989000,
					"to": 1458903330000,
					"color": "#F9C4E1"
				},
				{
					"desc": "Шаг 23",
					"from": 1334929209000,
					"to": 1334964989000,
					"color": "#D0E4FD"
				}
			]
		},
		{
			"name": "Шаг 1",
			"link": "#0",
			"values": [
				{
					"desc": "Шаг 1",
					"from": 1458903330000,
					"to": 1458903772000,
					"color": "#D0E4FD"
				}
			]
		},
		{
			"name": "Шаг 23",
			"link": "#0",
			"values": [
				{
					"desc": "Шаг 23",
					"from": 1458903772000,
					"to": 1458917411000,
					"color": "#D0E4FD"
				}
			]
		},
		{
			"name": "Шаг 1",
			"link": "#0",
			"values": [
				{
					"desc": "Шаг 1",
					"from": 1458917411000,
					"to": 1458917422000,
					"color": "#D0E4FD"
				}
			]
		},
		{
			"name": "Шаг 23",
			"link": "#0",
			"values": [
				{
					"desc": "Шаг 23",
					"from": 1458917422000,
					"to": 1458918928000,
					"color": "#D0E4FD"
				}
			]
		},
		{
			"name": "Шаг 1",
			"link": "#0",
			"values": [
				{
					"desc": "Шаг 1",
					"from": 1458918928000,
					"to": 1458919504000,
					"color": "#D0E4FD"
				}
			]
		},
		{
			"name": "Шаг 23",
			"link": "#0",
			"values": [
				{
					"desc": "Шаг 23",
					"from": 1458919504000,
					"to": 1459872409000,
					"color": "#D0E4FD"
				}
			]
		},
		{
			"name": "Шаг 1",
			"link": "#0",
			"values": [
				{
					"desc": "Шаг 1",
					"from": 1459872409000,
					"to": 1460993069000,
					"color": "#D0E4FD"
				}
			]
		},
		{
			"name": "Шаг 23",
			"link": "#0",
			"values": [
				{
					"desc": "Шаг 23",
					"from": 1460993069000,
					"to": 1461745330000,
					"color": "#D0E4FD"
				}
			]
		},
		{
			"name": "Шаг 1",
			"link": "#0",
			"values": [
				{
					"desc": "Шаг 1",
					"from": 1461745330000,
					"to": 1461745347000,
					"color": "#D0E4FD"
				}
			]
		},
		{
			"name": "Шаг 23",
			"link": "#0",
			"values": [
				{
					"desc": "Шаг 23",
					"from": 1461745347000,
					"to": 1461774181000,
					"color": "#D0E4FD"
				}
			]
		},
		{
			"name": "Шаг 1",
			"link": "#0",
			"values": [
				{
					"desc": "Шаг 1",
					"from": 1461774181000,
					"to": 1461777151000,
					"color": "#D0E4FD"
				}
			]
		},
		{
			"name": "Шаг 23",
			"link": "#0",
			"values": [
				{
					"desc": "Шаг 23 просрочен",
					"from": 1470417120000,
					"to": 1475072710000,
					"color": "#F9C4E1"
				},
				{
					"desc": "Шаг 23",
					"from": 1461777151000,
					"to": 1470417120000,
					"color": "#D0E4FD"
				}
			]
		},
		{
			"name": "Шаг 1",
			"link": "#0",
			"values": [
				{
					"desc": "Шаг 1",
					"from": 1483712640000,
					"to": 1499953482327,
					"color": "#F9C4E1"
				},
				{
					"desc": "Шаг 1",
					"from": 1475072710000,
					"to": 1483712640000,
					"color": "#D0E4FD"
				}
			]
		}
	],
	"legendHelp": "Help"
};

/***/ }),

/***/ 59:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Gantt__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__data_json__ = __webpack_require__(204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__data_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__data_json__);





__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  template: '<Gantt :data="data" />',
  components: { Gantt: __WEBPACK_IMPORTED_MODULE_1__components_Gantt__["a" /* default */] },
  data: function data() {
    return {
      data: __WEBPACK_IMPORTED_MODULE_2__data_json___default.a
    };
  }
});

/***/ }),

/***/ 61:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Gantt_vue__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0ce76d54_node_modules_vue_loader_lib_selector_type_template_index_0_Gantt_vue__ = __webpack_require__(203);
function injectStyle (ssrContext) {
  __webpack_require__(62)
}
var normalizeComponent = __webpack_require__(4)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0ce76d54"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Gantt_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0ce76d54_node_modules_vue_loader_lib_selector_type_template_index_0_Gantt_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 62:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 64:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__hellpers__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__GanttLegend__ = __webpack_require__(187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__GanttHeader__ = __webpack_require__(191);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__GanttBody__ = __webpack_require__(195);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__GanttFooter__ = __webpack_require__(199);









var defaultOptions = {
  cellWidth: 24,
  scales: [{ scale: 'months', steps: [1] }, { scale: 'days', steps: [1] }, { scale: 'hours', steps: [12, 8, 6, 3, 1] }, { scale: 'minutes', steps: [30, 15, 5, 1] }, { scale: 'seconds', steps: [30, 15, 5, 1] }]
};

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    GanttLegend: __WEBPACK_IMPORTED_MODULE_2__GanttLegend__["a" /* default */],
    GanttHeader: __WEBPACK_IMPORTED_MODULE_3__GanttHeader__["a" /* default */],
    GanttBody: __WEBPACK_IMPORTED_MODULE_4__GanttBody__["a" /* default */],
    GanttFooter: __WEBPACK_IMPORTED_MODULE_5__GanttFooter__["a" /* default */]
  },
  props: {
    data: {
      type: Object,
      required: true
    }
  },
  mounted: function mounted() {
    window.addEventListener('resize', this.setCellsCount);
    this.setCellsCount();
    var maxScaleIdx = Object(__WEBPACK_IMPORTED_MODULE_1__hellpers__["c" /* calcMaxScale */])(this.startDate, this.endDate, this.cellsCount, this.scales);

    var _scales$maxScaleIdx$s = this.scales[maxScaleIdx].split(' '),
        _scales$maxScaleIdx$s2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_scales$maxScaleIdx$s, 2),
        scale = _scales$maxScaleIdx$s2[0],
        step = _scales$maxScaleIdx$s2[1];

    this.scale = scale;
    this.step = step;
    this.scales = this.scales.filter(function (_, idx) {
      return idx >= maxScaleIdx;
    });
    this.viewportStart = this.min;
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('resize', this.setCellsCount);
  },
  data: function data() {
    return {
      viewportStart: 0,
      cellsCount: 0,
      scales: Object(__WEBPACK_IMPORTED_MODULE_1__hellpers__["e" /* createOptions */])(defaultOptions.scales),
      scale: defaultOptions.scales[0].scale,
      step: defaultOptions.scales[0].steps[0]
    };
  },

  computed: {
    parsedProps: function parsedProps() {
      var rows = this.data.rows;

      return Object(__WEBPACK_IMPORTED_MODULE_1__hellpers__["l" /* transformInputValues */])(rows);
    },
    legendHelp: function legendHelp() {
      return this.data.legendHelp;
    },
    startDate: function startDate() {
      return this.parsedProps.startDate;
    },
    endDate: function endDate() {
      return this.parsedProps.endDate;
    },
    values: function values() {
      return this.parsedProps.values.map(function (value) {
        return value.sort(function (a, b) {
          return a.from - b.from;
        });
      });
    },
    tasks: function tasks() {
      return this.parsedProps.tasks;
    },
    body: function body() {
      return Object(__WEBPACK_IMPORTED_MODULE_1__hellpers__["a" /* calcBody */])(this.viewport, this.values, this.msInCell, defaultOptions.cellWidth);
    },
    header: function header() {
      return Object(__WEBPACK_IMPORTED_MODULE_1__hellpers__["b" /* calcHeader */])(this.viewport, this.scale, this.step, defaultOptions.cellWidth);
    },
    max: function max() {
      return Object(__WEBPACK_IMPORTED_MODULE_1__hellpers__["g" /* getMaxDate */])(Object(__WEBPACK_IMPORTED_MODULE_1__hellpers__["f" /* getEndOfScale */])(this.scale, this.endDate) - Object(__WEBPACK_IMPORTED_MODULE_1__hellpers__["j" /* getViewportInMilliseconds */])(this.endDate, this.scale, this.step, this.cellsCount), this.min, this.msInCell);
    },
    min: function min() {
      return Object(__WEBPACK_IMPORTED_MODULE_1__hellpers__["h" /* getMinDate */])(this.startDate, this.scale);
    },
    msInCell: function msInCell() {
      return Object(__WEBPACK_IMPORTED_MODULE_1__hellpers__["i" /* getMsInScale */])(this.scale) * this.step;
    },
    viewport: function viewport() {
      return Object(__WEBPACK_IMPORTED_MODULE_1__hellpers__["d" /* calcViewport */])(this.viewportStart, this.scale, this.step, this.cellsCount);
    },
    selectedScaleIdx: function selectedScaleIdx() {
      var _this = this;

      return this.scales.findIndex(function (el) {
        return el === _this.scale + ' ' + _this.step;
      });
    }
  },
  methods: {
    setCellsCount: function setCellsCount() {
      this.cellsCount = Math.ceil((this.$el.clientWidth - this.$refs.legend.$el.clientWidth) / defaultOptions.cellWidth);
    },
    handleScaleChange: function handleScaleChange(e) {
      var _e$target$value$split = e.target.value.split(' '),
          _e$target$value$split2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_e$target$value$split, 2),
          scale = _e$target$value$split2[0],
          step = _e$target$value$split2[1];

      if (this.scale !== scale) this.scale = scale;
      if (this.step !== step) this.step = step;
      this.viewportStart = Object(__WEBPACK_IMPORTED_MODULE_1__hellpers__["k" /* normalizeDate */])(this.viewportStart, this.scale, this.step);
      if (this.viewportStart < this.min) this.viewportStart = this.min;
      if (this.viewportStart > this.max) this.viewportStart = this.max;
    },
    handlePeriodChange: function handlePeriodChange(e) {
      this.viewportStart = parseInt(e.target.value, 10);
    },
    handleWheel: function handleWheel(e) {
      var newViewportStart = e.deltaY > 0 ? this.viewportStart + this.msInCell : this.viewportStart - this.msInCell;
      if (e.deltaY > 0) {
        if (newViewportStart < this.max) {
          this.viewportStart = newViewportStart;
        } else {
          this.viewportStart = this.max;
        }
      } else if (e.deltaY < 0) {
        if (newViewportStart > this.min) {
          this.viewportStart = newViewportStart;
        } else {
          this.viewportStart = this.min;
        }
      }
    },
    handleHeaderClick: function handleHeaderClick(_ref) {
      var date = _ref.date,
          scale = _ref.scale;

      if (this.scales.includes(scale + ' 1')) {
        this.scale = scale;
        this.step = 1;
        if (date > this.max) this.viewportStart = this.max;else if (date < this.min) this.viewportStart = this.min;else this.viewportStart = date;
      }
    },
    handleTaskClick: function handleTaskClick(start) {
      var viewportStart = Object(__WEBPACK_IMPORTED_MODULE_1__hellpers__["k" /* normalizeDate */])(start, this.scale, this.step);
      this.viewportStart = Math.min(viewportStart, this.max);
    }
  }
});

/***/ }),

/***/ 90:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return createOptions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return transformInputValues; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return getMinDate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return getViewportInMilliseconds; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return getEndOfScale; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return getMaxDate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return getMsInScale; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return calcViewport; });
/* unused harmony export transformRow */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return calcBody; });
/* unused harmony export mGetMonthsInYear */
/* unused harmony export mGetMonthsInQuarter */
/* unused harmony export mGetDaysInYear */
/* unused harmony export mGetDaysInMonth */
/* unused harmony export mGetHoursInDay */
/* unused harmony export mGetMinutesInHour */
/* unused harmony export mGetSecondsInMinute */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return calcHeader; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return normalizeDate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return calcMaxScale; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_date_fns_parse__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_date_fns_parse___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_date_fns_parse__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_date_fns_min__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_date_fns_min___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_date_fns_min__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_date_fns_max__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_date_fns_max___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_date_fns_max__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_date_fns_get_time__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_date_fns_get_time___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_date_fns_get_time__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_date_fns_end_of_second__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_date_fns_end_of_second___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_date_fns_end_of_second__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_date_fns_end_of_minute__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_date_fns_end_of_minute___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_date_fns_end_of_minute__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_date_fns_end_of_hour__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_date_fns_end_of_hour___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_date_fns_end_of_hour__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_date_fns_end_of_day__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_date_fns_end_of_day___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_date_fns_end_of_day__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_date_fns_end_of_month__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_date_fns_end_of_month___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_date_fns_end_of_month__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_date_fns_end_of_year__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_date_fns_end_of_year___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_date_fns_end_of_year__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_date_fns_start_of_second__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_date_fns_start_of_second___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_date_fns_start_of_second__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_date_fns_start_of_minute__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_date_fns_start_of_minute___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_date_fns_start_of_minute__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_date_fns_start_of_hour__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_date_fns_start_of_hour___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_date_fns_start_of_hour__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_date_fns_start_of_day__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_date_fns_start_of_day___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_date_fns_start_of_day__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_date_fns_start_of_month__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_date_fns_start_of_month___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_date_fns_start_of_month__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_date_fns_start_of_quarter__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_date_fns_start_of_quarter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_date_fns_start_of_quarter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_date_fns_start_of_year__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_date_fns_start_of_year___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_date_fns_start_of_year__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_date_fns_difference_in_milliseconds__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_date_fns_difference_in_milliseconds___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_date_fns_difference_in_milliseconds__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_date_fns_get_year__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_date_fns_get_year___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_date_fns_get_year__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_date_fns_get_month__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_date_fns_get_month___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_date_fns_get_month__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_date_fns_get_date__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_date_fns_get_date___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22_date_fns_get_date__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_date_fns_get_day_of_year__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_date_fns_get_day_of_year___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23_date_fns_get_day_of_year__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_date_fns_get_hours__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_date_fns_get_hours___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24_date_fns_get_hours__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_date_fns_get_minutes__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_date_fns_get_minutes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25_date_fns_get_minutes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_date_fns_get_seconds__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_date_fns_get_seconds___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26_date_fns_get_seconds__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_date_fns_get_days_in_month__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_date_fns_get_days_in_month___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27_date_fns_get_days_in_month__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_date_fns_get_days_in_year__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_date_fns_get_days_in_year___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28_date_fns_get_days_in_year__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_date_fns_is_same_year__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_date_fns_is_same_year___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29_date_fns_is_same_year__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_date_fns_is_same_quarter__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_date_fns_is_same_quarter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_30_date_fns_is_same_quarter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_date_fns_is_same_month__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_date_fns_is_same_month___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_31_date_fns_is_same_month__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32_date_fns_is_same_day__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32_date_fns_is_same_day___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_32_date_fns_is_same_day__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33_date_fns_is_same_hour__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33_date_fns_is_same_hour___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_33_date_fns_is_same_hour__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34_date_fns_is_same_minute__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34_date_fns_is_same_minute___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_34_date_fns_is_same_minute__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35_date_fns_add_years__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35_date_fns_add_years___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_35_date_fns_add_years__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36_date_fns_add_quarters__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36_date_fns_add_quarters___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_36_date_fns_add_quarters__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37_date_fns_add_months__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37_date_fns_add_months___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_37_date_fns_add_months__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38_date_fns_add_days__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38_date_fns_add_days___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_38_date_fns_add_days__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39_date_fns_add_hours__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39_date_fns_add_hours___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_39_date_fns_add_hours__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40_date_fns_add_minutes__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40_date_fns_add_minutes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_40_date_fns_add_minutes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41_date_fns_add_seconds__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41_date_fns_add_seconds___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_41_date_fns_add_seconds__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42_date_fns_difference_in_days__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42_date_fns_difference_in_days___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_42_date_fns_difference_in_days__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43_date_fns_is_after__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43_date_fns_is_after___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_43_date_fns_is_after__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44_date_fns_is_before__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44_date_fns_is_before___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_44_date_fns_is_before__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45_date_fns_format__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45_date_fns_format___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_45_date_fns_format__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46_date_fns_compare_asc__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46_date_fns_compare_asc___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_46_date_fns_compare_asc__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47_lodash_memoize__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47_lodash_memoize___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_47_lodash_memoize__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48_lodash_capitalize__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48_lodash_capitalize___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_48_lodash_capitalize__);


















































var endDateFunctions = {
  seconds: __WEBPACK_IMPORTED_MODULE_6_date_fns_end_of_second___default.a,
  minutes: __WEBPACK_IMPORTED_MODULE_7_date_fns_end_of_minute___default.a,
  hours: __WEBPACK_IMPORTED_MODULE_8_date_fns_end_of_hour___default.a,
  days: __WEBPACK_IMPORTED_MODULE_9_date_fns_end_of_day___default.a,
  months: __WEBPACK_IMPORTED_MODULE_10_date_fns_end_of_month___default.a,
  years: __WEBPACK_IMPORTED_MODULE_11_date_fns_end_of_year___default.a
};

var startDateFunctions = {
  seconds: __WEBPACK_IMPORTED_MODULE_12_date_fns_start_of_second___default.a,
  minutes: __WEBPACK_IMPORTED_MODULE_13_date_fns_start_of_minute___default.a,
  hours: __WEBPACK_IMPORTED_MODULE_14_date_fns_start_of_hour___default.a,
  days: __WEBPACK_IMPORTED_MODULE_15_date_fns_start_of_day___default.a,
  months: __WEBPACK_IMPORTED_MODULE_16_date_fns_start_of_month___default.a,
  years: __WEBPACK_IMPORTED_MODULE_18_date_fns_start_of_year___default.a
};

var addDateFunctions = {
  seconds: __WEBPACK_IMPORTED_MODULE_41_date_fns_add_seconds___default.a,
  minutes: __WEBPACK_IMPORTED_MODULE_40_date_fns_add_minutes___default.a,
  hours: __WEBPACK_IMPORTED_MODULE_39_date_fns_add_hours___default.a,
  days: __WEBPACK_IMPORTED_MODULE_38_date_fns_add_days___default.a,
  months: __WEBPACK_IMPORTED_MODULE_37_date_fns_add_months___default.a,
  years: __WEBPACK_IMPORTED_MODULE_35_date_fns_add_years___default.a
};

var getDateFunctions = {
  seconds: __WEBPACK_IMPORTED_MODULE_26_date_fns_get_seconds___default.a,
  minutes: __WEBPACK_IMPORTED_MODULE_25_date_fns_get_minutes___default.a,
  hours: __WEBPACK_IMPORTED_MODULE_24_date_fns_get_hours___default.a,
  days: __WEBPACK_IMPORTED_MODULE_22_date_fns_get_date___default.a,
  months: __WEBPACK_IMPORTED_MODULE_21_date_fns_get_month___default.a,
  years: __WEBPACK_IMPORTED_MODULE_20_date_fns_get_year___default.a
};

var intervals = {
  months: 'years',
  days: 'months',
  hours: 'days',
  minutes: 'hours',
  seconds: 'minutes'
};

var createOptions = function createOptions(scales) {
  if (Array.isArray(scales)) {
    return scales.reduce(function (acc, _ref) {
      var scale = _ref.scale,
          steps = _ref.steps;

      if (Array.isArray(steps)) {
        return [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(acc), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(steps.map(function (step) {
          return scale + ' ' + step;
        })));
      }
      throw new TypeError('Expected array');
    }, []);
  }
  throw new TypeError('Expected array');
};

var transformInputValues = function transformInputValues(rows) {
  return rows.reduce(function (acc, _ref2) {
    var link = _ref2.link,
        name = _ref2.name,
        values = _ref2.values;

    var dates = values.reduce(function (r, _ref3) {
      var from = _ref3.from,
          to = _ref3.to;
      return {
        startDate: r.startDate ? __WEBPACK_IMPORTED_MODULE_3_date_fns_min___default()(r.startDate, __WEBPACK_IMPORTED_MODULE_2_date_fns_parse___default()(from)) : __WEBPACK_IMPORTED_MODULE_2_date_fns_parse___default()(from),
        endDate: r.endDate ? __WEBPACK_IMPORTED_MODULE_4_date_fns_max___default()(r.endDate, __WEBPACK_IMPORTED_MODULE_2_date_fns_parse___default()(to)) : __WEBPACK_IMPORTED_MODULE_2_date_fns_parse___default()(to)
      };
    }, {});
    var task = {
      link: link,
      from: __WEBPACK_IMPORTED_MODULE_45_date_fns_format___default()(dates.startDate, 'DD-MM-YYYY HH:mm:ss'),
      to: __WEBPACK_IMPORTED_MODULE_45_date_fns_format___default()(dates.endDate, 'DD-MM-YYYY HH:mm:ss'),
      name: name,
      start: __WEBPACK_IMPORTED_MODULE_5_date_fns_get_time___default()(dates.startDate)
    };
    return {
      startDate: acc.startDate ? __WEBPACK_IMPORTED_MODULE_3_date_fns_min___default()(acc.startDate, dates.startDate) : dates.startDate,
      endDate: acc.endDate ? __WEBPACK_IMPORTED_MODULE_4_date_fns_max___default()(acc.endDate, dates.endDate) : dates.endDate,
      values: [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(acc.values), [values]),
      tasks: [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(acc.tasks), [task])
    };
  }, { values: [], tasks: [] });
};

var getMinDate = function getMinDate(startDate, scale) {
  var method = startDateFunctions[intervals[scale]];
  return __WEBPACK_IMPORTED_MODULE_5_date_fns_get_time___default()(method(startDate));
};

var getViewportInMilliseconds = function getViewportInMilliseconds(start, scale, step, cellsCount) {
  var startDate = __WEBPACK_IMPORTED_MODULE_2_date_fns_parse___default()(start);
  var endDate = addDateFunctions[scale](__WEBPACK_IMPORTED_MODULE_2_date_fns_parse___default()(start), cellsCount * parseInt(step, 10));
  return __WEBPACK_IMPORTED_MODULE_19_date_fns_difference_in_milliseconds___default()(endDate, startDate);
};

var getEndOfScale = function getEndOfScale(scale, endDate) {
  var method = endDateFunctions[intervals[scale]];
  return __WEBPACK_IMPORTED_MODULE_5_date_fns_get_time___default()(method(endDate));
};

var getMaxDate = function getMaxDate(maxDate, minDate, msInCell) {
  var date = Math.max(maxDate, minDate);
  return date + (msInCell - (date - minDate) % msInCell);
};

var getMsInScale = __WEBPACK_IMPORTED_MODULE_47_lodash_memoize___default()(function (scale) {
  switch (scale) {
    case 'months':
      return 2678400000;
    case 'days':
      return 86400000;
    case 'hours':
      return 3600000;
    case 'minutes':
      return 60000;
    case 'seconds':
      return 1000;
    default:
      return new Error('Invalid format');
  }
});

var calcViewport = function calcViewport(start, scale, step, cellsCount) {
  var startDate = __WEBPACK_IMPORTED_MODULE_2_date_fns_parse___default()(start);
  var endDate = addDateFunctions[scale](__WEBPACK_IMPORTED_MODULE_2_date_fns_parse___default()(start), cellsCount * parseInt(step, 10));
  return { startDate: startDate, endDate: endDate };
};

var transformRow = function transformRow(_ref4, msInCell, cellWidth) {
  var startDate = _ref4.startDate,
      endDate = _ref4.endDate;
  return function (_ref5, idx) {
    var from = _ref5.from,
        to = _ref5.to,
        desc = _ref5.desc,
        color = _ref5.color;

    var msInCellWithTolerance = msInCell === 2678400000 ? 365 / 12 * 8.64e7 : msInCell;
    var offset = idx === 0 && __WEBPACK_IMPORTED_MODULE_43_date_fns_is_after___default()(from, startDate) && __WEBPACK_IMPORTED_MODULE_44_date_fns_is_before___default()(from, endDate) ? Math.ceil((from - startDate) / msInCellWithTolerance * cellWidth) : 0;
    var intervalStart = __WEBPACK_IMPORTED_MODULE_44_date_fns_is_before___default()(from, startDate) && __WEBPACK_IMPORTED_MODULE_43_date_fns_is_after___default()(to, startDate) ? startDate : from;
    var intervalEnd = __WEBPACK_IMPORTED_MODULE_44_date_fns_is_before___default()(from, endDate) && __WEBPACK_IMPORTED_MODULE_43_date_fns_is_after___default()(to, endDate) ? endDate : to;
    var display = !(__WEBPACK_IMPORTED_MODULE_46_date_fns_compare_asc___default()(from, endDate) >= 0 || __WEBPACK_IMPORTED_MODULE_46_date_fns_compare_asc___default()(to, startDate) <= 0);
    var width = Math.ceil((intervalEnd - intervalStart) / msInCellWithTolerance * cellWidth);
    return {
      width: width,
      offset: width < 8 && offset > 0 ? offset - (8 - width) : offset,
      desc: desc,
      color: color,
      display: display,
      from: __WEBPACK_IMPORTED_MODULE_45_date_fns_format___default()(from, 'DD-MM-YYYY HH:mm:ss'),
      to: __WEBPACK_IMPORTED_MODULE_45_date_fns_format___default()(to, 'DD-MM-YYYY HH:mm:ss')
    };
  };
};

var calcBody = function calcBody(_ref6, rows, msInCell, cellWidth) {
  var startDate = _ref6.startDate,
      endDate = _ref6.endDate;
  return rows.map(function (row) {
    return row.map(transformRow({ startDate: startDate, endDate: endDate }, msInCell, cellWidth));
  });
};

var mGetMonthsInYear = __WEBPACK_IMPORTED_MODULE_47_lodash_memoize___default()(function (start, end) {
  if (__WEBPACK_IMPORTED_MODULE_29_date_fns_is_same_year___default()(start, end)) {
    return __WEBPACK_IMPORTED_MODULE_21_date_fns_get_month___default()(end) - __WEBPACK_IMPORTED_MODULE_21_date_fns_get_month___default()(start);
  }
  return 12 - __WEBPACK_IMPORTED_MODULE_21_date_fns_get_month___default()(start);
});

var mGetMonthsInQuarter = __WEBPACK_IMPORTED_MODULE_47_lodash_memoize___default()(function (start, end) {
  if (__WEBPACK_IMPORTED_MODULE_30_date_fns_is_same_quarter___default()(start, end)) {
    return __WEBPACK_IMPORTED_MODULE_21_date_fns_get_month___default()(end) - __WEBPACK_IMPORTED_MODULE_21_date_fns_get_month___default()(start);
  }
  return 3 - __WEBPACK_IMPORTED_MODULE_21_date_fns_get_month___default()(start) % 3;
});

var mGetDaysInYear = __WEBPACK_IMPORTED_MODULE_47_lodash_memoize___default()(function (start, end) {
  if (__WEBPACK_IMPORTED_MODULE_29_date_fns_is_same_year___default()(start, end)) {
    return __WEBPACK_IMPORTED_MODULE_42_date_fns_difference_in_days___default()(end, start) + 1;
  }
  return __WEBPACK_IMPORTED_MODULE_28_date_fns_get_days_in_year___default()(start) - __WEBPACK_IMPORTED_MODULE_23_date_fns_get_day_of_year___default()(start) + 1;
});

var mGetDaysInMonth = __WEBPACK_IMPORTED_MODULE_47_lodash_memoize___default()(function (start, end) {
  if (__WEBPACK_IMPORTED_MODULE_31_date_fns_is_same_month___default()(start, end)) {
    var maxDays = (__WEBPACK_IMPORTED_MODULE_5_date_fns_get_time___default()(end) - __WEBPACK_IMPORTED_MODULE_5_date_fns_get_time___default()(start)) / 86400000;
    var days = __WEBPACK_IMPORTED_MODULE_22_date_fns_get_date___default()(end) - __WEBPACK_IMPORTED_MODULE_22_date_fns_get_date___default()(start) + 1;
    return Math.min(days, maxDays);
  }
  return __WEBPACK_IMPORTED_MODULE_27_date_fns_get_days_in_month___default()(start) - __WEBPACK_IMPORTED_MODULE_22_date_fns_get_date___default()(start) - __WEBPACK_IMPORTED_MODULE_24_date_fns_get_hours___default()(start) / 24 + 1;
});

var mGetHoursInDay = __WEBPACK_IMPORTED_MODULE_47_lodash_memoize___default()(function (start, end, step) {
  if (__WEBPACK_IMPORTED_MODULE_32_date_fns_is_same_day___default()(start, end)) {
    var maxHours = (__WEBPACK_IMPORTED_MODULE_5_date_fns_get_time___default()(end) - __WEBPACK_IMPORTED_MODULE_5_date_fns_get_time___default()(start)) / 3600000 / step;
    var hours = (__WEBPACK_IMPORTED_MODULE_24_date_fns_get_hours___default()(end) - __WEBPACK_IMPORTED_MODULE_24_date_fns_get_hours___default()(start) + 1) / step;
    return Math.min(hours, maxHours);
  }
  return (24 - __WEBPACK_IMPORTED_MODULE_24_date_fns_get_hours___default()(start) - __WEBPACK_IMPORTED_MODULE_25_date_fns_get_minutes___default()(start) / 60) / step;
});

var mGetMinutesInHour = __WEBPACK_IMPORTED_MODULE_47_lodash_memoize___default()(function (start, end, step) {
  if (__WEBPACK_IMPORTED_MODULE_33_date_fns_is_same_hour___default()(start, end)) {
    var maxMinutes = (__WEBPACK_IMPORTED_MODULE_5_date_fns_get_time___default()(end) - __WEBPACK_IMPORTED_MODULE_5_date_fns_get_time___default()(start)) / 60000 / step;
    var minutes = (__WEBPACK_IMPORTED_MODULE_25_date_fns_get_minutes___default()(end) - __WEBPACK_IMPORTED_MODULE_25_date_fns_get_minutes___default()(start) - __WEBPACK_IMPORTED_MODULE_26_date_fns_get_seconds___default()(start) / 60 + 1) / step;
    return Math.min(minutes, maxMinutes);
  }
  return (60 - __WEBPACK_IMPORTED_MODULE_25_date_fns_get_minutes___default()(start) - __WEBPACK_IMPORTED_MODULE_26_date_fns_get_seconds___default()(start) / 60) / step;
});

var mGetSecondsInMinute = __WEBPACK_IMPORTED_MODULE_47_lodash_memoize___default()(function (start, end, step) {
  if (__WEBPACK_IMPORTED_MODULE_34_date_fns_is_same_minute___default()(start, end)) {
    return (__WEBPACK_IMPORTED_MODULE_26_date_fns_get_seconds___default()(end) - __WEBPACK_IMPORTED_MODULE_26_date_fns_get_seconds___default()(start)) / step;
  }
  return (60 - __WEBPACK_IMPORTED_MODULE_26_date_fns_get_seconds___default()(start)) / step;
});

var switchScale = function switchScale(scale, step) {
  switch (scale) {
    case 'months':
      return [{
        method: function method(date) {
          return __WEBPACK_IMPORTED_MODULE_48_lodash_capitalize___default()(__WEBPACK_IMPORTED_MODULE_45_date_fns_format___default()(date, 'YYYY'));
        },
        addType: __WEBPACK_IMPORTED_MODULE_35_date_fns_add_years___default.a,
        start: __WEBPACK_IMPORTED_MODULE_18_date_fns_start_of_year___default.a,
        add: 1,
        factor: 1,
        scale: 'months',
        get: mGetMonthsInYear
      }, {
        method: function method(date) {
          return __WEBPACK_IMPORTED_MODULE_48_lodash_capitalize___default()(__WEBPACK_IMPORTED_MODULE_45_date_fns_format___default()(date, 'Q'));
        },
        addType: __WEBPACK_IMPORTED_MODULE_36_date_fns_add_quarters___default.a,
        start: __WEBPACK_IMPORTED_MODULE_17_date_fns_start_of_quarter___default.a,
        add: 1,
        factor: 1,
        scale: 'months',
        get: mGetMonthsInQuarter
      }, {
        method: function method(date) {
          return __WEBPACK_IMPORTED_MODULE_48_lodash_capitalize___default()(__WEBPACK_IMPORTED_MODULE_45_date_fns_format___default()(date, 'M'));
        },
        addType: __WEBPACK_IMPORTED_MODULE_37_date_fns_add_months___default.a,
        start: __WEBPACK_IMPORTED_MODULE_16_date_fns_start_of_month___default.a,
        add: 1,
        factor: 1,
        scale: 'days',
        get: function get() {
          return 1;
        }
      }];
    case 'days':
      return [{
        method: function method(date) {
          return __WEBPACK_IMPORTED_MODULE_48_lodash_capitalize___default()(__WEBPACK_IMPORTED_MODULE_45_date_fns_format___default()(date, 'YYYY'));
        },
        addType: __WEBPACK_IMPORTED_MODULE_35_date_fns_add_years___default.a,
        start: __WEBPACK_IMPORTED_MODULE_18_date_fns_start_of_year___default.a,
        add: 1,
        factor: 1,
        scale: 'months',
        get: mGetDaysInYear
      }, {
        method: function method(date) {
          return __WEBPACK_IMPORTED_MODULE_48_lodash_capitalize___default()(__WEBPACK_IMPORTED_MODULE_45_date_fns_format___default()(date, 'MMM'));
        },
        addType: __WEBPACK_IMPORTED_MODULE_37_date_fns_add_months___default.a,
        start: __WEBPACK_IMPORTED_MODULE_16_date_fns_start_of_month___default.a,
        add: 1,
        factor: 1,
        scale: 'months',
        get: mGetDaysInMonth
      }, {
        method: function method(date) {
          return __WEBPACK_IMPORTED_MODULE_48_lodash_capitalize___default()(__WEBPACK_IMPORTED_MODULE_45_date_fns_format___default()(date, 'D'));
        },
        addType: __WEBPACK_IMPORTED_MODULE_38_date_fns_add_days___default.a,
        start: __WEBPACK_IMPORTED_MODULE_15_date_fns_start_of_day___default.a,
        add: parseInt(step, 10),
        factor: 1,
        scale: 'hours',
        get: function get() {
          return 1;
        }
      }];
    case 'hours':
      return [{
        method: function method(date) {
          return __WEBPACK_IMPORTED_MODULE_48_lodash_capitalize___default()(__WEBPACK_IMPORTED_MODULE_45_date_fns_format___default()(date, 'MMM'));
        },
        addType: __WEBPACK_IMPORTED_MODULE_37_date_fns_add_months___default.a,
        start: __WEBPACK_IMPORTED_MODULE_16_date_fns_start_of_month___default.a,
        add: 1,
        factor: 24 / step,
        scale: 'days',
        get: mGetDaysInMonth
      }, {
        method: function method(date) {
          return __WEBPACK_IMPORTED_MODULE_48_lodash_capitalize___default()(__WEBPACK_IMPORTED_MODULE_45_date_fns_format___default()(date, 'D'));
        },
        addType: __WEBPACK_IMPORTED_MODULE_38_date_fns_add_days___default.a,
        start: __WEBPACK_IMPORTED_MODULE_15_date_fns_start_of_day___default.a,
        add: 1,
        factor: 1,
        scale: 'hours',
        get: mGetHoursInDay
      }, {
        method: function method(date) {
          return __WEBPACK_IMPORTED_MODULE_48_lodash_capitalize___default()(__WEBPACK_IMPORTED_MODULE_45_date_fns_format___default()(date, 'H'));
        },
        addType: __WEBPACK_IMPORTED_MODULE_39_date_fns_add_hours___default.a,
        start: __WEBPACK_IMPORTED_MODULE_14_date_fns_start_of_hour___default.a,
        add: parseInt(step, 10),
        factor: 1,
        scale: 'minutes',
        get: function get() {
          return 1;
        }
      }];
    case 'minutes':
      return [{
        method: function method(date) {
          return __WEBPACK_IMPORTED_MODULE_48_lodash_capitalize___default()(__WEBPACK_IMPORTED_MODULE_45_date_fns_format___default()(date, 'D'));
        },
        addType: __WEBPACK_IMPORTED_MODULE_38_date_fns_add_days___default.a,
        start: __WEBPACK_IMPORTED_MODULE_15_date_fns_start_of_day___default.a,
        add: 1,
        factor: 60,
        scale: 'hours',
        get: mGetHoursInDay
      }, {
        method: function method(date) {
          return __WEBPACK_IMPORTED_MODULE_48_lodash_capitalize___default()(__WEBPACK_IMPORTED_MODULE_45_date_fns_format___default()(date, 'H'));
        },
        addType: __WEBPACK_IMPORTED_MODULE_39_date_fns_add_hours___default.a,
        start: __WEBPACK_IMPORTED_MODULE_14_date_fns_start_of_hour___default.a,
        add: 1,
        factor: 1,
        scale: 'minutes',
        get: mGetMinutesInHour
      }, {
        method: function method(date) {
          return __WEBPACK_IMPORTED_MODULE_48_lodash_capitalize___default()(__WEBPACK_IMPORTED_MODULE_45_date_fns_format___default()(date, 'm'));
        },
        addType: __WEBPACK_IMPORTED_MODULE_40_date_fns_add_minutes___default.a,
        start: __WEBPACK_IMPORTED_MODULE_13_date_fns_start_of_minute___default.a,
        add: parseInt(step, 10),
        factor: 1,
        scale: 'seconds',
        get: function get() {
          return 1;
        }
      }];
    case 'seconds':
      return [{
        method: function method(date) {
          return __WEBPACK_IMPORTED_MODULE_48_lodash_capitalize___default()(__WEBPACK_IMPORTED_MODULE_45_date_fns_format___default()(date, 'H'));
        },
        addType: __WEBPACK_IMPORTED_MODULE_39_date_fns_add_hours___default.a,
        start: __WEBPACK_IMPORTED_MODULE_14_date_fns_start_of_hour___default.a,
        add: 1,
        factor: 60,
        scale: 'minutes',
        get: mGetMinutesInHour
      }, {
        method: function method(date) {
          return __WEBPACK_IMPORTED_MODULE_48_lodash_capitalize___default()(__WEBPACK_IMPORTED_MODULE_45_date_fns_format___default()(date, 'm'));
        },
        addType: __WEBPACK_IMPORTED_MODULE_40_date_fns_add_minutes___default.a,
        start: __WEBPACK_IMPORTED_MODULE_13_date_fns_start_of_minute___default.a,
        add: 1,
        factor: 1,
        scale: 'seconds',
        get: mGetSecondsInMinute
      }, {
        method: function method(date) {
          return __WEBPACK_IMPORTED_MODULE_48_lodash_capitalize___default()(__WEBPACK_IMPORTED_MODULE_45_date_fns_format___default()(date, 's'));
        },
        addType: __WEBPACK_IMPORTED_MODULE_41_date_fns_add_seconds___default.a,
        start: __WEBPACK_IMPORTED_MODULE_12_date_fns_start_of_second___default.a,
        add: parseInt(step, 10),
        factor: 1,
        scale: 'seconds',
        get: function get() {
          return 1;
        }
      }];
    default:
      return new Error('Invalid format');
  }
};

var calcHeader = __WEBPACK_IMPORTED_MODULE_47_lodash_memoize___default()(function (_ref7, scale, step, cellWidth) {
  var startDate = _ref7.startDate,
      endDate = _ref7.endDate;
  return switchScale(scale, step).map(function (sc) {
    var tmp = [];
    for (var date = new Date(__WEBPACK_IMPORTED_MODULE_5_date_fns_get_time___default()(startDate)); __WEBPACK_IMPORTED_MODULE_44_date_fns_is_before___default()(date, endDate); date = sc.start(sc.addType(date, sc.add))) {
      tmp.push({
        scale: sc.scale,
        date: __WEBPACK_IMPORTED_MODULE_5_date_fns_get_time___default()(date),
        label: sc.method(date),
        title: __WEBPACK_IMPORTED_MODULE_45_date_fns_format___default()(date, 'DD-MM-YYYY HH:mm:ss'),
        width: cellWidth * sc.get(date, endDate, step) * sc.factor
      });
    }
    return tmp;
  });
});

var normalizeDate = function normalizeDate(date, scale, step) {
  var startOfPeriod = __WEBPACK_IMPORTED_MODULE_5_date_fns_get_time___default()(startDateFunctions[scale](date));
  var rest = getDateFunctions[scale](startOfPeriod) % step;
  return rest ? __WEBPACK_IMPORTED_MODULE_5_date_fns_get_time___default()(addDateFunctions[scale](startOfPeriod, -rest)) : startOfPeriod;
};

var calcMaxScale = function calcMaxScale(start, end, cellsCount, scales) {
  var realDiff = __WEBPACK_IMPORTED_MODULE_5_date_fns_get_time___default()(end) - __WEBPACK_IMPORTED_MODULE_5_date_fns_get_time___default()(start);
  return scales.reduceRight(function (acc, s, idx) {
    var _s$split = s.split(' '),
        _s$split2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_s$split, 2),
        scale = _s$split2[0],
        step = _s$split2[1];

    var _calcViewport = calcViewport(getMinDate(start, scale), scale, step, cellsCount),
        startDate = _calcViewport.startDate,
        endDate = _calcViewport.endDate;

    return __WEBPACK_IMPORTED_MODULE_5_date_fns_get_time___default()(endDate) - __WEBPACK_IMPORTED_MODULE_5_date_fns_get_time___default()(startDate) > realDiff && idx > acc ? idx : acc;
  }, 0);
};

/***/ })

},[59]);


// WEBPACK FOOTER //
// static/js/app.0cb02816cdce15692fff.js